// extracted by mini-css-extract-plugin
export var quantityInput = "_dh-0";